<template>
  <div id="about">
    <Title></Title>

    <div>
      <Benefit></Benefit>
    </div>

    <div style="background-color: #1E49AC">
      <!-- <LearnMore></LearnMore> -->
    </div>
  </div>
</template>

<script>
import Title from './Title.vue';
import Benefit from './Benefit.vue';
import LearnMore from './LearnMore.vue';

export default {
  name: 'About',
  components: { Title, Benefit, LearnMore },
  data() {
    return {};
  },
  methods: {
    scrollToTop() {
      document.getElementById('about').scrollIntoView();
    }
  },
  created() {},
  mounted() {
    this.scrollToTop();
  }
};
</script>

<style scoped></style>
